import { shallowRef } from "vue";

export const _topbarContentsComponent = shallowRef();

export function provideTopBarContents(component) {
  _topbarContentsComponent.value = component
}
